$(() => {
  const productForm = $('[data-product-form]');
  const addToCartButton = $('#js-add-to-cart-button');
  const addToCartButtonText = $('#js-add-to-cart-button-text');
  const addToCartButtonSpinner = $('#js-add-to-cart-button-spinner');

  const relatedForm = $('#js-product-add-related-form');
  const relatedFormAddCartButton = $('#js-product-add-related-cart-button');
  const relatedFormAddCartButtonText = $(
    '#js-product-add-related-cart-button-text'
  );
  const relatedFormAddCartButtonSpinner = $(
    '#js-product-add-related-cart-button-spinner'
  );

  const cartCountBubble = $('[data-cart-count-bubble]');
  const cartCount = $('[data-cart-count]');
  const cartPopup = $('.cart_popup');
  const cartPopupCloseButton = $('#js-cart-popup-close-button');
  const cartPopupProductList = $('#js-cart-popup-product-list');
  const cartPopupItemCount = $('#js-cart-popup-item-count');

  function hideCartPopup() {
    cartPopup.addClass('cart_popup_hide');
  }
  function showCartPopup() {
    cartPopup.removeClass('cart_popup_hide');
  }

  function updateCartItemCount(cartItemCount) {
    // カートアイコン 個数更新
    cartCountBubble.removeClass('p-header__cart-count--hidden');
    cartCount.text(cartItemCount);
    // カートドロワー 個数更新
    cartPopupItemCount.text(cartItemCount);
  }

  function getSizedImageUrl(src, size) {
    let match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );
    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];
      return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '');
    }
    return null;
  }

  function updateCartPopupContent(items) {
    let productList = '';
    items.forEach((item) => {
      // 商品オプション一覧DOM
      let optionList = '';
      if (!item.product_has_only_default_variant) {
        optionListElements = '';
        item.options_with_values.forEach((option_with_value) => {
          optionListElements += `<li class="cart_popup_product_list_item_detail_option_list_item">${option_with_value.name} : ${option_with_value.value}</li>`;
        });
        optionList = `<ul class="cart_popup_product_list_item_detail_option_list">${optionListElements}</ul>`;
      }
      // 商品DOM
      let imageUrl = getSizedImageUrl(item.featured_image.url, '200x');
      productList += `
        <li class="cart_popup_product_list_item js-cart-popup-product-list-item" id="js-cart-popup-product-list-item-${item.id}">
          <div class="cart_popup_product_list_item_left_wrapper">
            <img src=${imageUrl} alt="${item.featured_image.alt}" class="cart_popup_product_list_item_image">
            <div class="cart_popup_product_list_item_detail">
              <h3 class="cart_popup_product_list_item_detail_title">${item.product_title}</h3>
              ${optionList}
            </div>
          </div>
          <input
            type="image"
            value="${item.key}"
            data-variantid="${item.id}"
            class="cart_popup_product_list_item_delete_button"
            src="https://cdn.shopify.com/s/files/1/0430/4961/5510/files/EcoSmart_Fire_cartpopup_close.svg?v=1658206623">
        </li>
      `;
    });
    cartPopupProductList.html(productList);
  }

  function decrementItemInCartPopup(lineItemKey, variantID) {
    $.getJSON('/cart.js').done((cart) => {
      cart.items.forEach((item) => {
        if (item.key === lineItemKey) {
          let params = {
            url: '/cart/change.js',
            data: { id: lineItemKey, quantity: item.quantity - 1 },
            dataType: 'json',
          };
          $.post(params).done((data) => {
            updateCartItemCount(data.item_count);
            $(`#js-cart-popup-product-list-item-${variantID}`).remove();
            // 表示商品がなくなった場合はドロワーを非表示にする
            if ($('.js-cart-popup-product-list-item').length === 0) {
              hideCartPopup();
            }
          });
        }
      });
    });
  }

  function handleButtonLoadingState(
    isLoading,
    buttonText,
    buttonSpinner,
    buttonElement
  ) {
    if (isLoading) {
      buttonText.hide();
      buttonSpinner.show();
      buttonElement.attr('disabled', true);
    } else {
      buttonText.show();
      buttonSpinner.hide();
      buttonElement.attr('disabled', false);
    }
  }

  function handleAddToCartButtonLoadingState(isLoading) {
    handleButtonLoadingState(
      isLoading,
      addToCartButtonText,
      addToCartButtonSpinner,
      addToCartButton
    );
  }

  function handleRelatedFormAddCartButtonLoadingState(isLoading) {
    handleButtonLoadingState(
      isLoading,
      relatedFormAddCartButtonText,
      relatedFormAddCartButtonSpinner,
      relatedFormAddCartButton
    );
  }

  function addItemsToCart(data) {
    hideCartPopup();
    let params = {
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
    };
    $.post(params)
      .done((data) => {
        $.getJSON('/cart.js').done((cart) => {
          updateCartItemCount(cart.item_count);
          // 本商品か関連商品かに応じて`data`の形式が異なる。
          // 本商品: data = {'id': 999, ...}
          // 関連商品: data = {'items': [{'id': 999, ...}, ...]}
          if ('items' in data) {
            updateCartPopupContent(data.items);
          } else {
            updateCartPopupContent([data]);
          }
          showCartPopup();

          // 削除ボタン
          let cartPopupDecrementButtons = $(
            '.cart_popup_product_list_item_delete_button'
          );
          cartPopupDecrementButtons.on('click', function () {
            decrementItemInCartPopup(this.value, $(this).data('variantid'));
          });
        });
      })
      .fail((response) => {
        console.log(response);
      })
      .always(() => {
        handleAddToCartButtonLoadingState(false);
        handleRelatedFormAddCartButtonLoadingState(false);
      });
  }

  // 本商品 カート追加ボタンが押された時
  productForm.submit(function (event) {
    event.preventDefault();
    handleAddToCartButtonLoadingState(true);
    let data = $(productForm).serialize();
    addItemsToCart(data);
  });

  // 合わせて購入 カート追加ボタンが押された時
  relatedForm.submit(function (event) {
    let items = [];
    event.preventDefault();
    handleRelatedFormAddCartButtonLoadingState(true);

    // メインの商品を取得
    // パラメーターにvariantがあるときはパラメーターのvariantを優先
    // なければ初期のvariantIdを取得してかーとに入れる
    let url = new URL(window.location.href);
    let param = url.searchParams.get('variant');
    if (param) {
      items.push({ id: param });
    } else {
      const data = $(productForm).serializeArray();
      const variantId = data.find((p) => p.name == 'id');
      if (variantId) {
        items.push({ id: variantId.value });
      }
    }
    // 合わせて購入
    let relatedFormCheckedCheckboxes = $('input[name=related-product]:checked');
    relatedFormCheckedCheckboxes.each((_, checkbox) => {
      items.push({ id: checkbox.value });
    });
    // e-NRG追加
    let relatedFormSelectEnrgValue = document.getElementById('select_enrg');
    if (relatedFormSelectEnrgValue) {
      if (relatedFormSelectEnrgValue.value) {
        items.push({ id: relatedFormSelectEnrgValue.value });
      }
    }
    // アダプター追加
    let relatedFormSelectAdapterValue =
      document.getElementById('select_adapter').value;
    if (relatedFormSelectAdapterValue) {
      items.push({ id: relatedFormSelectAdapterValue });
    }
    // 開梱設置追加
    let relatedFormSelectUnpackingValue =
      document.getElementById('select_unpacking');
    if (relatedFormSelectUnpackingValue) {
      if (relatedFormSelectUnpackingValue.value) {
        items.push({ id: relatedFormSelectUnpackingValue.value });
      }
    }
    console.log(items);

    addItemsToCart({ items: items });
  });

  cartPopupCloseButton.click(function () {
    hideCartPopup();
  });
});
